import {bookApi} from '@vio/core/src/booking/services/bookApi'

import {ModuleActionType} from './actions'
import {bookOfferFinalizationError} from './actions/bookOfferFinalization'
import {BOOK_OFFER_PSD2_ERROR} from './actions/bookOfferPsd2'
import sliceReducer from './slice'

export interface BookStateType {
  offerBookState: string | null
}

export const initialState: BookStateType = {
  offerBookState: null
}

const bookReducer = (
  state: BookStateType = initialState,
  action: ModuleActionType
) => {
  if (bookApi.endpoints.createBooking.matchPending(action)) {
    return {
      ...state,
      offerBookState: ''
    }
  }

  switch (action.type) {
    case bookOfferFinalizationError.type:
    case BOOK_OFFER_PSD2_ERROR: {
      return {
        ...state,
        offerBookState: action.type
      }
    }

    default: {
      return sliceReducer(state, action)
    }
  }
}

export default bookReducer
